
import React, { useRef, useEffect } from 'react';

interface DateInfo {
    full: string;
    day: number;
    weekday: string;
    month: string;
}

interface DateStripProps {
    dates: DateInfo[];
    selectedDate?: string;
    todayStr: string;
    onDateChange: (date: string) => void;
}

export const DateStrip: React.FC<DateStripProps> = ({ dates, selectedDate, todayStr, onDateChange }) => {
    const stripRef = useRef<HTMLDivElement>(null);

    // 선택된 날짜로 부드러운 스크롤 이동
    useEffect(() => {
        if (selectedDate && stripRef.current) {
            const selectedBtn = stripRef.current.querySelector(`[data-date="${selectedDate}"]`);
            if (selectedBtn) {
                selectedBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
        }
    }, [selectedDate]);

    return (
        <div className="sticky top-[49px] z-30 md:top-0 shadow-sm">
            <div className="max-w-[800px] mx-auto px-0">
                <div ref={stripRef} className="flex overflow-x-auto no-scrollbar gap-2.5 px-1 py-4 snap-x">
                    {dates.map((d, idx) => {
                        const isSelected = selectedDate ? selectedDate === d.full : idx === 0;
                        const isToday = d.full === todayStr;
                        return (
                            <button 
                                key={d.full} 
                                data-date={d.full}
                                onClick={() => onDateChange(d.full)} 
                                className={`flex flex-col items-center justify-center min-w-[60px] h-[62px] rounded-[22px] snap-start border ${
                                    isSelected 
                                    ? 'bg-slate-900 text-white border-slate-900 shadow-md' 
                                    : 'bg-white text-slate-400'
                                }`}
                            >
                                <span className={`text-[9px] font-black mb-1 ${isSelected ? 'text-rose-400' : isToday ? 'text-rose-500' : 'text-gray-300'}`}>
                                    {d.weekday}{isToday && " •"}
                                </span>
                                <span className="text-[11px] font-black leading-none uppercase tracking-tighter tabular-nums">
                                    {d.month} {d.day}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
